import { Metamodel } from 'app/model/base/model';
import { AzureBlobStorageLinkedService } from 'app/model/linkedservice/azure-blob-storage.linkedservice';
import { BlobTypeStoreReadSettings } from './blob-type-store-read-settings';
import { IAttribute } from 'app/model/base/annotation';

import { FilePathMode } from 'app/registries/consts/metadata-consts';
import { StoreReadSettings } from './store-read-settings';

@Metamodel.model({
    name: 'AzureBlobStorageReadSettings',
    display: [],
    tags: {
        linkedServiceModel: [Metamodel.modelFor(AzureBlobStorageLinkedService)]
    }
})

export class AzureBlobReadSettings extends BlobTypeStoreReadSettings {
    public static readonly PREFIX: IAttribute;
    public supportedFilePathMode = [
        FilePathMode.DATASET,
        FilePathMode.PREFIX,
        FilePathMode.WILDCARD,
        FilePathMode.LIST
    ];

    @Metamodel.attribute({
        templatable: true,
        association: 'PREFIX',
        display: stringResources.Prefix
    })
    public prefix?: string;

    public recoverPropFromPrevOne(prevStoreSettings: StoreReadSettings): void {
        super.recoverPropFromPrevOne(prevStoreSettings);
        this.updateModelValue('prefix', this, prevStoreSettings);
    }
}
